import { RepositoryFactory } from '@/repositories/PassageApi/RepositoryFactory.js'

const LessonRepository = RepositoryFactory.get('lesson')

class LessonService {
  static async getLessons () {
    try {
      return await LessonRepository.getLessons()
    } catch (error) {
      console.log(error)
    }
  }

  static async getLesson (lessonId, params) {
    try {
      return await LessonRepository.getLesson(lessonId, params)
    } catch (error) {
      console.log(error)
    }
  }
}

export default LessonService
